import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  filterConfig,
  IconOption,
  inputSelectCustomStyles,
  StyledAsyncPaginate
} from './CustomSearchBar';

const SmartLockAsyncDropDown = ({
  value,
  setValue,
  disabled = false,
  onChange,
  setHasLock,
  error,
  style = {},
  idAttribute,
  nameAttribute

}) => {
  const { building, locks } = useSelector((state) => state.building);
  const { unit } = useSelector((state) => state.unit);

  const noLockValue = {
    value: value[idAttribute],
    label: value[nameAttribute],
  };

  const [lock, setLock] = useState(noLockValue);

  useEffect(() => {
    if (locks.length > 0 && unit) {
      const pairedLock = locks.find(lock => lock.unit_id === unit?.id);
      if(pairedLock) {
        setLock({ 
          value: pairedLock[idAttribute],
          label: pairedLock[nameAttribute],
        });
        handleSetValue(pairedLock);
        setHasLock(true);
      }
    }
  }, [locks, unit]);
    

  const availableLocks = useMemo(() => {
    const devices = [
      value,
      ...locks.filter(lock => {
        return !lock?.unit_id || lock.unit_id === unit?.id;
      }),
    ];
    
    return [...new Map(devices.map(item => [item[idAttribute], item])).values()];
  }, [locks, unit]);

  const handleSetValue = (value) => {
    if (onChange) {
      onChange(value);
    } else {
      setValue(value);
    }
  };

  const handleOnChange = (item) => {
    const selectedLock = getLock(item);
    if(!selectedLock) return;
    handleSetValue(selectedLock);
    setLock(item);
  };

  const loadOptions = useCallback(() => {
    return {
      options: availableLocks.map(lock => ({
        value: lock[idAttribute],
        label: lock[nameAttribute],
      })),
      hasMore: false,
    };
  },[availableLocks]);

  const getLock = useCallback((item) => {
    if (!item?.value && !item?.label) return undefined;
    return availableLocks.find(device => device[idAttribute] === item.value);
  },[availableLocks]);
  
  return (
    <div style={style}>
      <StyledAsyncPaginate
        menuShouldScrollIntoView={true}
        captureMenuScroll={false}
        menuShouldBlockScroll={false}
        filterOption={filterConfig}
        debounceTimeout={500}
        key={`lock-select-${building?.id}-${unit?.id}-${availableLocks?.length}`}
        name="lock"
        className="react-select-container"
        classNamePrefix="react-select"
        value={lock}
        isDisabled={!building?.id || !unit?.id || disabled}
        onChange={handleOnChange}
        styles={inputSelectCustomStyles({ height: '56px' })}
        components={{
          IndicatorSeparator: () => null,
          Option: IconOption,
        }}
        loadOptions={loadOptions}
        error={error}
      />
    </div>
  );
};

export default memo(SmartLockAsyncDropDown);